import { render, staticRenderFns } from "./ArchiveDownload.vue?vue&type=template&id=0a8adfb4&scoped=true"
import script from "./ArchiveDownload.vue?vue&type=script&lang=ts"
export * from "./ArchiveDownload.vue?vue&type=script&lang=ts"
import style0 from "./ArchiveDownload.vue?vue&type=style&index=0&id=0a8adfb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8adfb4",
  null
  
)

export default component.exports